import { CHANNEL_TYPES, MOODS_MIXPANEL_CONSTANT } from '@libs/constants';
import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { EVENT } from '../../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { getMixpanelLinearProperties, getMixpanelVodProperties } from '../../../contexts/MixpanelHelper';
import h from '../../../helpers/common';
import { feelingLuckyQueryOptions } from '../../../hooks/useFeelingLucky';
import { __ } from '../../../translations';
import { ChannelsCarousel } from '../../ui/ChannelsCarousel';
import { VodCarousel } from '../../ui/VodCarousel';
import Loader from './elements/Loader';
import NoContentBanner from './elements/NoContentBanner';
import { IMixpanelContext } from './interface';
import { log } from '@intigral/utils';

const Lucky = ({ mood, onChangeMood }) => {
    const { track } = useContext(MixpanelContext);
    const {
        data: luckyData = { data: [], isVOD: false, genre: '', category: '' },
        isLoading: loading,
        error,
    } = useQuery(feelingLuckyQueryOptions());

    const { data, isVOD, genre, category } = luckyData;

    const getCapitalisedText = (text: string) => {
        return typeof text === 'string' && text.length > 0
            ? `${text[0].toUpperCase()}${text.slice(1).toLowerCase()}`
            : '';
    };

    const getTransformedTitle = () => {
        let title = __(mood?.title_resource_key || 'moods_lucky_carousel_title');
        title = title.replace('{genre}', getCapitalisedText(genre));
        title = title.replace('{category}', getCapitalisedText(category));
        return title;
    };

    const sendMPEventOnChannelClick = (item, index) => {
        track(EVENT.MOODS.MOOD_ITEM_CLICK, {
            'Mood Type': MOODS_MIXPANEL_CONSTANT[mood?.type || ''],
            'Mood Category': 'NA',
            ...(isVOD ? getMixpanelVodProperties(item) : getMixpanelLinearProperties(item)),
            'Row Index': index,
        });
    };

    if (!loading && (!data || data.length === 0 || error)) {
        return <NoContentBanner onChangeMood={onChangeMood} />;
    }

    const title = { title: { [h.getLang()]: getTransformedTitle() } };

    return (
        <>
            {loading && (
                <Loader length={6} onChangeMood={onChangeMood} title={__('mood_recommendation_categories_title')} />
            )}
            {!loading &&
                (isVOD ? (
                    <VodCarousel
                        content={data || []}
                        meta={title}
                        MoodChangeElement={{
                            // <Link to="#" className="seeAll" onClick={onChangeMood}>
                            //     {__('moods_change_mood_text')}
                            // </Link>
                            onClick: onChangeMood,
                            seeAllText: __('moods_change_mood_text'),
                            seeAllUrl: '#',
                        }}
                        onItemClick={sendMPEventOnChannelClick}
                    />
                ) : (
                    <ChannelsCarousel
                        id="channel-results"
                        data_stream={CHANNEL_TYPES.EMBED_CHANNELS}
                        content={data}
                        meta={title}
                        params={{ items_count: data.length }}
                        onSeeAllClick={onChangeMood}
                        seeAllText={__('moods_change_mood_text')}
                        seeAllUrl="#"
                        onChannelClick={sendMPEventOnChannelClick}
                    />
                ))}
        </>
    );
};

export default Lucky;
